import {
  AdNetworksEventsMapping,
  AnalyticsEventsMapping,
  FacebookPixelEventsMapping,
  FirebaseEventsMapping,
  TikTokPixelEventsMapping,
} from './types';

export enum FacebookPixelDefaultEvents {
  'ViewContent' = 'ViewContent',
  'Lead' = 'Lead',
  'CompleteRegistration' = 'CompleteRegistration',
  'Purchase' = 'Purchase',
  'Subscribe' = 'Subscribe',
  'InitiateCheckout' = 'InitiateCheckout',
}

const AdNetworksEvents: AdNetworksEventsMapping = {
  InitiateCheckout: {
    eventName: 'InitiateCheckout',
    services: ['tiktok', 'facebook'],
    ignoreGlobalProps: true,
  },
  Lead: {
    eventName: 'Lead',
    services: ['tiktok', 'facebook'],
    ignoreGlobalProps: true,
  },
  CompleteRegistration: {
    eventName: 'CompleteRegistration',
    services: ['tiktok', 'facebook'],
    ignoreGlobalProps: true,
  },
  Purchase: {
    eventName: 'Purchase',
    services: ['tiktok', 'facebook'],
    ignoreGlobalProps: true,
  },
  Subscribe: {
    eventName: 'Subscribe',
    services: ['tiktok', 'facebook'],
    ignoreGlobalProps: true,
  },
};

export const TikTokPixelEvents: TikTokPixelEventsMapping = AdNetworksEvents;

export const FacebookPixelEvents: FacebookPixelEventsMapping = {
  ...AdNetworksEvents,
  ViewContent: {
    eventName: 'ViewContent',
    services: ['facebook'],
    ignoreGlobalProps: true,
  },
  AppOpened: {
    eventName: 'AppOpened',
    services: ['facebook'],
    ignoreGlobalProps: true,
  },
};

export const FirebaseEvents: FirebaseEventsMapping = {
  refund: {
    eventName: 'refund',
    services: ['firebase'],
    ignoreGlobalProps: true,
  },
  purchase: {
    eventName: 'purchase',
    services: ['firebase'],
    ignoreGlobalProps: true,
  },
  purchase_subscription: {
    eventName: 'purchase_subscription',
    services: ['firebase'],
    ignoreGlobalProps: true,
  },
  client_sign_up: {
    eventName: 'client_sign_up',
    services: ['firebase'],
    ignoreGlobalProps: true,
  },
};

export const AnalyticsEvents: AnalyticsEventsMapping = {
  FUNNEL_STARTED: {
    eventName: 'FunnelStarted',
    services: ['mixpanel'],
  },
  FUNNEL_START_CLICKED: {
    eventName: 'FunnelStartClicked',
    services: ['mixpanel'],
  },
  FUNNEL_SKIP_CLICKED: {
    eventName: 'FunnelSkipClicked',
    services: ['mixpanel'],
  },
  FUNNEL_SCREEN_VIEWED: {
    eventName: 'FunnelScreenViewed',
    services: ['mixpanel'],
  },
  FUNNEL_ANSWERS: {
    eventName: 'FunnelAnswers',
    services: ['mixpanel'],
  },
  FUNNEL_COMPLETED: {
    eventName: 'FunnelCompleted',
    services: ['mixpanel'],
  },
  FUNNEL_CONTINUE_CLICKED: {
    eventName: 'FunnelContinueClicked',
    services: ['mixpanel'],
  },
  FUNNEL_REGISTRATION_EMAIL_SCREEN_VIEWED: {
    eventName: 'FunnelRegistrationEmailScreenViewed',
    services: ['mixpanel'],
  },
  FUNNEL_REGISTRATION_CONFIRMATION_SCREEN_VIEWED: {
    eventName: 'FunnelRegistrationConfirmationScreenViewed',
    services: ['mixpanel'],
  },
  FUNNEL_REGISTRATION_EMAIL_CONTINUE_CLICKED: {
    eventName: 'FunnelRegistrationEmailContinueClicked',
    services: ['mixpanel'],
  },
  FUNNEL_REGISTRATION_CONFIRMATION_CONTINUE_CLICKED: {
    eventName: 'FunnelRegistrationConfirmationContinueClicked',
    services: ['mixpanel'],
  },
  FUNNEL_PAYWALL_SCREEN_VIEWED: {
    eventName: 'FunnelPaywallScreenViewed',
    services: ['mixpanel'],
  },
  FUNNEL_PAYWALL_SCROLL_50_PERCENT: {
    eventName: 'FunnelPaywallScroll50Percent',
    services: ['mixpanel'],
  },
  FUNNEL_PAYWALL_SCROLL_100_PERCENT: {
    eventName: 'FunnelPaywallScroll100Percent',
    services: ['mixpanel'],
  },
  FUNNEL_PAYWALL_PURCHASE_BUTTON_CLICKED: {
    eventName: 'FunnelPaywallPurchaseButtonClick',
    services: ['mixpanel'],
  },
  FUNNEL_PAYWALL_GET_MY_SESSION_CLICKED: {
    eventName: 'FunnelPaywallGetMySessionClick',
    services: ['mixpanel'],
  },
  FUNNEL_PAYWALL_PLAN_INFO_VIEWED: {
    eventName: 'FunnelPaywallPlanInfoViewed',
    services: ['mixpanel'],
  },
  FUNNEL_CHECKOUT_SCREEN_VIEWED: {
    eventName: 'FunnelCheckoutScreenViewed',
    services: ['mixpanel'],
  },
  FUNNEL_CHECKOUT_PAY_NOW_BUTTON_CLICKED: {
    eventName: 'FunnelCheckoutPayNowButtonClick',
    services: ['mixpanel'],
  },
  FUNNEL_CHECKOUT_PAYMENT_RETRY_AFTER_PASSWORD: {
    eventName: 'FunnelCheckoutPaymentRetryAfterPassword',
    services: ['mixpanel'],
  },
  FUNNEL_PAYWALL_DISCOUNT_OFFERED: {
    eventName: 'FunnelPaywallDiscountOffered',
    services: ['mixpanel'],
  },
  FUNNEL_PAYWALL_GET_DISCOUNT_BUTTON_CLICKED: {
    eventName: 'FunnelPaywallGetDiscountButtonClick',
    services: ['mixpanel'],
  },
  USER_REGISTRATION: {
    eventName: 'UserRegistration',
    services: ['mixpanel'],
  },
  SPECIALIST_LIST_VIEWED: {
    eventName: 'SpecialistListViewed',
    services: ['mixpanel'],
  },
  SPECIALIST_PROFILE_VIEWED: {
    eventName: 'SpecialistProfileViewed',
    services: ['mixpanel'],
  },
  TRIAL_SCHEDULE_SCREEN_VIEWED: {
    eventName: 'TrialScheduleScreenViewed',
    services: ['mixpanel'],
  },
  TRIAL_SCHEDULE_DATE_SELECTED: {
    eventName: 'TrialScheduleDateSelected',
    services: ['mixpanel'],
  },
  TRIAL_CHECKOUT_SCREEN_VIEWED: {
    eventName: 'TrialCheckoutScreenViewed',
    services: ['mixpanel'],
  },
  TRIAL_CHECKOUT_PAY_BUTTON_CLICKED: {
    eventName: 'TrialCheckoutPayButtonClicked',
    services: ['mixpanel'],
  },
  SUBSCRIPTION_PAGE_VIEWED: {
    eventName: 'SubscriptionPageViewed',
    services: ['mixpanel'],
  },
  SUBSCRIPTION_CHECKOUT_SCREEN_VIEWED: {
    eventName: 'SubscriptionCheckoutScreenViewed',
    services: ['mixpanel'],
  },
  SUBSCRIPTION_SCHEDULE_SCREEN_VIEWED: {
    eventName: 'SubscriptionScheduleScreenViewed',
    services: ['mixpanel'],
  },
  EXPERIMENT_STARTED: {
    eventName: '$experiment_started',
    services: ['mixpanel'],
    ignoreGlobalProps: true,
  },
  SPECIALIST_LIST_FILTER_BUTTON_CLICKED: {
    eventName: 'SpecialistListFilterButtonClicked',
    services: ['mixpanel'],
  },
  SPECIALIST_LIST_FILTERS_SUBMITTED: {
    eventName: 'SpecialistListFiltersSubmitted',
    services: ['mixpanel'],
  },
  SPECIALIST_LIST_SPECIALIST_PROFILE_CLICKED: {
    eventName: 'SpecialistListSpecialistProfileClicked',
    services: ['mixpanel'],
  },
  SPECIALIST_PROFILE_SCROLL_50_PERCENT: {
    eventName: 'SpecialistProfileScroll50Percent',
    services: ['mixpanel'],
  },
  SPECIALIST_PROFILE_SCROLL_100_PERCENT: {
    eventName: 'SpecialistProfileScroll100Percent',
    services: ['mixpanel'],
  },
  TRIAL_SCHEDULE_SCREEN_SLOTS_VIEWED: {
    eventName: 'TrialScheduleScreenSlotsViewed',
    services: ['mixpanel'],
  },
  LOGIN_GET_STARTED_VIEWED: {
    eventName: 'LoginGetStartedViewed',
    services: ['mixpanel'],
  },
  LOGIN_GOOGLE_BUTTON_CLICKED: {
    eventName: 'LoginGoogleButtonClicked',
    services: ['mixpanel'],
  },
  LOGIN_APPLE_BUTTON_CLICKED: {
    eventName: 'LoginAppleButtonClicked',
    services: ['mixpanel'],
  },
  LOGIN_EMAIL_BUTTON_CLICKED: {
    eventName: 'LoginEmailButtonClicked',
    services: ['mixpanel'],
  },
  SIGNUP_ACCOUNT_ALREADY_EXISTS_VIEWED: {
    eventName: 'SignupAccountAlreadyExistsViewed',
    services: ['mixpanel'],
  },
  SIGNUP_USER_INFO_VIEWED: {
    eventName: 'SignupUserInfoViewed',
    services: ['mixpanel'],
  },
  SIGNUP_USER_INFO_SUBMITTED: {
    eventName: 'SignupUserInfoSubmitted',
    services: ['mixpanel'],
  },
  NOTIFICATION_PERMISSION_VIEWED: {
    eventName: 'NotificationPermissionViewed',
    services: ['mixpanel'],
  },
  NOTIFICATION_PERMISSION_CLICKED: {
    eventName: 'NotificationPermissionClicked',
    services: ['mixpanel'],
  },
  SCHEDULE_SCREEN_VIEWED: {
    eventName: 'ScheduleScreenViewed',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  SESSION_DETAILS_SCREEN_VIEWED: {
    eventName: 'SessionDetailsScreenViewed',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  SESSION_START_BUTTON_CLICKED: {
    eventName: 'SessionStartButtonClicked',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  SESSION_STARTED: {
    eventName: 'SessionStarted',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  THERAPY_SESSION_STARTED: {
    eventName: 'TherapySessionStarted',
    services: ['mixpanel'],
  },
  THERAPY_SESSION_COMPLETED: {
    eventName: 'TherapySessionCompleted',
    services: ['mixpanel'],
  },
  FAVOURITES_SCREEN_VIEWED: {
    eventName: 'FavouritesScreenViewed',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  CHAT_LIST_VIEWED: {
    eventName: 'ChatListViewed',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  PROFILE_SCREEN_VIEWED: {
    eventName: 'ProfileScreenViewed',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  PROFILE_USER_DATA_SCREEN_VIEWED: {
    eventName: 'ProfileUserDataScreenViewed',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  PROFILE_DELETE_ACCOUNT_BUTTON_CLICKED: {
    eventName: 'ProfileDeleteAccountButtonClicked',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  PROFILE_DELETE_ACCOUNT_BUTTON_SUBMITTED: {
    eventName: 'ProfileDeleteAccountButtonSubmitted',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  SUBSCRIPTION_PAUSE_SCREEN_VIEWED: {
    eventName: 'SubscriptionPauseScreenViewed',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  SUBSCRIPTION_PAUSE_CONFIRMATION_MODAL_CLICKED: {
    eventName: 'SubscriptionPauseConfirmationModalClicked',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  SUBSCRIPTION_PAUSE_COMPLETED: {
    eventName: 'SubscriptionPauseCompleted',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  SUBSCRIPTION_CANCEL_SCREEN_VIEWED: {
    eventName: 'SubscriptionCancelScreenViewed',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  SUBSCRIPTION_CANCEL_REASON_MODAL_CLICKED: {
    eventName: 'SubscriptionCancelReasonModalClicked',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  SUBSCRIPTION_CANCEL_COMPLETED: {
    eventName: 'SubscriptionCancelCompleted',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  SUBSCRIPTION_RESTART_SCREEN_VIEWED: {
    eventName: 'SubscriptionRestartScreenViewed',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  SUBSCRIPTION_RESTART_COMPLETED: {
    eventName: 'SubscriptionRestartCompleted',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },
  SUBSCRIPTION_CHECKOUT_PAY_BUTTON_CLICKED: {
    eventName: 'SubscriptionCheckoutPayButtonClicked',
    services: ['mixpanel'],
    ignoreGloablEventProps: ['onboarding_experiment_name'],
  },

  SCHEDULE_SCREEN_RATE_SESSION_CLICKED: {
    eventName: 'ScheduleScreenRateSessionClicked',
    services: ['mixpanel'],
  },
  RATING_SCREEN_VIEWED: {
    eventName: 'SessionRatingScreenViewed',
    services: ['mixpanel'],
  },
  RATING_BUTTON_CLICKED: {
    eventName: 'RatingButtonClicked',
    services: ['mixpanel'],
  },
  RATING_REASON_SELECTED: {
    eventName: 'RatingReasonSelected',
    services: ['mixpanel'],
  },
  RATING_BUTTON_CLOSED_CLICKED: {
    eventName: 'RatingButtonClosedClicked',
    services: ['mixpanel'],
  },
  RATING_DISCOUNT_OFFERED: {
    eventName: 'TrialSessionRatingDiscountOffered',
    services: ['mixpanel'],
  },
  RATING_NEXT_SESSION_SCREEN_VIEWED: {
    eventName: 'RatingNextSessionScreenViewed',
    services: ['mixpanel'],
  },
  RATING_NEXT_SESSION_CONTINUE_CLICKED: {
    eventName: 'RatingNextSessionContinueClicked',
    services: ['mixpanel'],
  },
  RATING_NEXT_SESSION_CLOSE_CLICKED: {
    eventName: 'RatingNextSessionCloseClicked',
    services: ['mixpanel'],
  },
  RATING_PUBLIC_SCREEN_VIEWED: {
    eventName: 'RatingPublicScreenViewed',
    services: ['mixpanel'],
  },
  RATING_PUBLIC_RATE_CLICKED: {
    eventName: 'RatingPublicRateClicked',
    services: ['mixpanel'],
  },
  RATING_PUBLIC_REVIEW_SUBMITTED: {
    eventName: 'RatingPublicReviewSubmitted',
    services: ['mixpanel'],
  },
  RATING_PUBLIC_REVIEW_UPDATED: {
    eventName: 'RatingPublicReviewUpdated',
    services: ['mixpanel'],
  },
  NPS_SCREEN_VIEWED: {
    eventName: 'NpsScreenViewed',
    services: ['mixpanel'],
  },
  NPS_RATING_STARS_SELECTED: {
    eventName: 'NpsRateClicked',
    services: ['mixpanel'],
  },
  NPS_FEEDBACK_SCREEN_VIEWED: {
    eventName: 'NpsCommentModalAppeared',
    services: ['mixpanel'],
  },
  NPS_FEEDBACK_COMPLETED: {
    eventName: 'NpsFeedbackCompleted',
    services: ['mixpanel'],
  },
  NPS_INTERVIEW_SCREEN_VIEWED: {
    eventName: 'NpsInterviewScreenViewed',
    services: ['mixpanel'],
  },
  NPS_INTERVIEW_SCREEN_SUBMITTED: {
    eventName: 'NpsInterviewScreenSubmitted',
    services: ['mixpanel'],
  },

  SPECIALIST_PROFILE_SUPER_SPECIALIST_CLICKED: {
    eventName: 'SpecialistProfileSuperSpecialistClicked',
    services: ['mixpanel'],
  },
  SPECIALIST_PROFILE_NEW_SPECIALIST_CLICKED: {
    eventName: 'SpecialistProfileNewSpecialistClicked',
    services: ['mixpanel'],
  },
  SPECIALIST_PROFILE_VIDEO_COVER_CLICKED: {
    eventName: 'SpecialistProfileVideoCoverClicked',
    services: ['mixpanel'],
  },
  SPECIALIST_PROFILE_VIDEO_BUTTON_CLICKED: {
    eventName: 'SpecialistProfileVideoButtonClicked',
    services: ['mixpanel'],
  },
  SPECIALIST_PROFILE_TAB_CLICKED: {
    eventName: 'SpecialistProfileTabClicked',
    services: ['mixpanel'],
  },
  SPECIALIST_PROFILE_MORE_BUTTON_CLICKED: {
    eventName: 'SpecialistProfileMoreButtonClicked',
    services: ['mixpanel'],
  },
  SPECIALIST_PROFILE_REVIEWS_MODAL_VIEWED: {
    eventName: 'SpecialistReviewsModalViewed',
    services: ['mixpanel'],
  },
  SPECIALIST_PROFILE_SLOTS_VIEWED: {
    eventName: 'SpecialistProfileSlotsViewed',
    services: ['mixpanel'],
  },
  SPECIALIST_PROFILE_SLOT_SELECTED: {
    eventName: 'SpecialistProfileSlotSelected',
    services: ['mixpanel'],
  },
  SPECIALIST_LIST_SLOT_SELECTED: {
    eventName: 'SpecialistListSlotSelected',
    services: ['mixpanel'],
  },
  SPECIALIST_LIST_SHOW_ALL_SLOTS_CLICKED: {
    eventName: 'SpecialistListShowAllSlotsClicked',
    services: ['mixpanel'],
  },
  BOOKING_CONFIRMATION_MODAL_VIEWED: {
    eventName: 'BookingConfirmationModalViewed',
    services: ['mixpanel'],
  },
  BOOKING_CONFIRMATION_MODAL_CLICKED: {
    eventName: 'BookingConfirmationModalClicked',
    services: ['mixpanel'],
  },
  LOGIN_SELECT_LANGUAGE_VIEWED: {
    eventName: 'LoginSelectLanguageViewed',
    services: ['mixpanel'],
  },
  LOGIN_SELECT_LANGUAGE_SELECTED: {
    eventName: 'LoginSelectLanguageSelected',
    services: ['mixpanel'],
  },
  LOGIN_LANGUAGE_UNSUPPORTED_VIEWED: {
    eventName: 'LoginLanguageUnsupportedViewed',
    services: ['mixpanel'],
  },
  LOGIN_LANGUAGE_UNSUPPORTED_EMAIL_PROVIDED: {
    eventName: 'LoginLanguageUnsupportedEmailProvided',
    services: ['mixpanel'],
  },

  ...TikTokPixelEvents,
  ...FacebookPixelEvents,
  ...FirebaseEvents,
};

export enum UTM_PARAMS {
  // Default UTM parameters
  UTM_SOURCE = 'utm_source',
  UTM_MEDIUM = 'utm_medium',
  UTM_FUNNEL = 'utm_funnel',
  UTM_CAMPAIGN = 'utm_campaign',
  UTM_PLACEMENT = 'utm_placement',

  // Facebook UTM parameters
  UTM_ADNAME = 'utm_adname',
  UTM_ADSET = 'utm_adset',
  UTM_AD_ID = 'utm_ad_id',
  UTM_ADSET_ID = 'utm_adset_id',
  UTM_CAMPAIGN_ID = 'utm_campaign_id',

  // Google UTM parameters
  UTM_ADGROUP = 'utm_adgroup',
  UTM_TERM = 'utm_term',
  UTM_CREATIVE = 'utm_creative',
  UTM_NETWORK = 'utm_network',
}
